module.exports = __webpack_public_path__ + "02_long_black.d5fd5934.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_long_black.png
// module id = NS37
// module chunks = 0